import { useEffect, useState } from "react";
import PageEnum from "../../enum/PageEnum";
import WeatherEnum from "../../enum/WeatherEnum";
import { getAirportCode } from "../../store/airport/AirportSelector";
import { screenNameActions } from "../../store/screen/ScreenNameSlice";
import { useAppDispatch, useAppSelector } from "../../store/StoreHooks";
import { WEATHER_KPI_TABS } from "../../utils/weather/WeatherConstants";
import { AmdTabs } from "../common/tabs/tabs";
import WeatherForecast from "./forecast/WeatherForecast";
import WeatherKPI from "./kpi/WeatherKPI";
import { ExtendedRunway } from "./runway/ExtendedRunway";
import RunwayWind from "./runway/RunwayWind";

export const Weather: React.FunctionComponent = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const viewType = queryParams.get("viewType");
  const [selectedKPITab, setSelectedKPITab] = useState("today");

  const airport = useAppSelector((state) => getAirportCode(state));

  const onWeatherKPIFilterClick = (changedFilter: string) => {
    setSelectedKPITab(changedFilter);
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(screenNameActions.setScreenName(PageEnum.BreadcrumbEnum.Weather));
  }, [dispatch]);

  return (
    <>
      {viewType && viewType === "extended" ? (
        <ExtendedRunway airport={airport} />
      ) : (
        <>
          <h1 className="amd-heading1">Weather</h1>
          <div data-testid="weatherContainer">
            <AmdTabs
              selectedTab={selectedKPITab}
              defaultSelectedTab={WeatherEnum.WeatherKPITabs.Today}
              tabList={WEATHER_KPI_TABS.data}
              onTabClick={onWeatherKPIFilterClick}
              dataTestId="WeatherKPITabs"
            />
            {selectedKPITab === WeatherEnum.WeatherKPITabs.Today && (
              <WeatherKPI airport={airport} />
            )}
            {selectedKPITab === WeatherEnum.WeatherKPITabs.Today && (
              <RunwayWind airport={airport} />
            )}

            <WeatherForecast airport={airport} />
          </div>
        </>
      )}
    </>
  );
};
